import request from '@/services/axios'

//查询应用列表
export const getBotList = (data:any)=>{
    return request.post('/api/bot/list', data)
}

//首页热门应用
export const getBotHome = (data:any)=>{
    return request.post('/api/bot/home', data)
}

//应用中心分类列表
export const getBotCategoryList = (data:any = {})=>{
    return request.post('/api/bot/category/list', data)
}

//应用详情
export const getBotInfo = (data:any)=>{
    return request.post('/api/bot/info', data)
}
//弹窗弹出通知
export const miscPopNotify = (data:any)=>{
    return request.post('/api/misc/pop/notify', data)
}
